import { Component, Input } from '@angular/core';


@Component({
  selector: 'artemis-button-toggle-item',
  templateUrl: './button-toggle-item.component.html',
  styleUrls: ['./button-toggle-item.component.scss']
})
export class ButtonToggleItemComponent {

  @Input() set value(value: string) {
    this._value = value;
  }

  private _value: string;
  public parent: any;
  isActive: boolean;
  isDisabled: boolean;

  constructor() { }
  attach(parent: any) {
    if (!this.parent) {
      this.parent = parent;
      this.parent.completed.asObservable().subscribe(i => {
        if (this._value !== i) {
          this.isActive = false;
        } else {
          this.isActive = true;
        }
      });
    }
  }

  select() {
    if (!this.isDisabled) {
      this.isActive = true;
      this.parent.changeToggle(this._value);
    }
  }
  disable(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }
}
